// ==============================
// dynamic-host.component.ts
// ==============================
import { Component, Input } from '@angular/core';

@Component({
  selector: 'dynamic-host',
  template: `
    <div appEditableText [innerHTML]="htmlContent"></div>`,
  standalone: false,
})
export class DynamicHostComponent {
  htmlContent = '';

  @Input() set html(value: string) {
    if (!value) return;
    this.htmlContent = value;
  }
}
